<!--注销结算专户或注销企业账户-->
<template>
  <div v-loading="loading" class="payment-account-user">
    <div class="module">
      <h5 class="module-title">注销{{ accountType | accountTypeDesc }}</h5>
      <div class="module-tips">提示：{{ accountType | tipsText }}</div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="注销原因："
              prop="applyReason"
              :rules="rules.applyReason"
              label-width="100px"
            >
              <el-input
                v-model="ruleForm.applyReason"
                type="textarea"
                placeholder="请输入内容"
                maxlength="100"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--      申请人信息-->
    <applicant-info ref="applicantInfo"></applicant-info>
    <div style="margin-top: 20px" class="footer-button">
      <eui-btn type="secondary" @click="handleReturn">返 回</eui-btn>
      <div>
        <eui-btn type="weak" @click="handleReturn">取 消</eui-btn>
        <eui-btn type="primary" @click="handleSubmit">提 交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import bus from '@/components/common/bus';
import _ from 'lodash';
import ApplicantInfo from './applicantInfo';
import { logoutCompanyAccount } from '../constant';

export default {
  name: 'AddUser',
  components: { ApplicantInfo },
  filters: {
    tipsText(val) {
      if (val === 0) {
        return '注销易支付账户后，XXXXX！';
      }
      if (val === 1) {
        return '请检查已开立易权通是否已全部清算完成，若仍存在未清算的易权通，将无法完成账户注销。';
      }
      if (val === 2) {
        return '注销产融还款户后，您将无法继续进行阳光产融专区相关业务，请确认是否注销。';
      }

      return '注销支付账户会同时注销公司已开通的电商专户，易权通专户、产融还款专户。请确认是否注销支付账户！';
    },
    accountTypeDesc(type) {
      const accountList = [
        { label: '易支付账户', value: 0 },
        { label: '易权通清算户', value: 1 },
        { label: '产融还款专户', value: 2 },
        { label: '企业账户', value: logoutCompanyAccount },
      ];
      return accountList.find((item) => item.value === type)?.label;
    },
  },
  data() {
    return {
      loading: false,
      accountType: null,
      ruleForm: {
        applyReason: '',
      },
      rules: {
        applyReason: [
          { required: true, message: '请输入注销原因', trigger: 'blur' },
        ],
      },
      logoutCompanyAccount,
    };
  },
  watch: {},
  created() {
    this.accountType = Number(this.$route.query.accountType);
  },
  methods: {
    async initData() {},
    // 提交
    async handleSubmit() {
      const formName = ['applicantInfo'];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]?.$refs.ruleForm) {
            reject();
          }
          this.$refs[item].$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            }
          });
        });
      };
      const userForm = new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([userForm, ...formName.map((item) => validates(item))]).then(
        () => {
          this.handleSave();
        }
      );
    },
    // 保存
    async handleSave() {
      const params = {
        ..._.cloneDeep(this.$refs.applicantInfo.ruleForm),
        ...this.ruleForm,
      };
      params.accountUserApplicantAttachAOList.forEach((item) => {
        // 申请人证件
        if (item.attachType === 'AC') {
          item.certificateValidityBegin = item.certificateTimeRange?.[0];
          item.certificateValidityEnd = item.certificateTimeRange?.[1];
          delete item.certificateTimeRange;
        }
        item.isLongTernEffective = item.isLongTernEffective ? 1 : 0;
      });
      // 注销企业账户
      let submitUrl = 'cancelEpayAccount';
      // 注销易权通和产融专户
      if (this.accountType === 2 || this.accountType === 1) {
        submitUrl = 'cancelEpayAccountSub';
        params.accountType = this.accountType;
      }
      console.log(params, 'params');
      Api[submitUrl](params).then((res) => {
        if (res.code === '200') {
          this.$message.success('提交成功');
          this.handleReturn();
        }
      });
    },
    handleReturn() {
      bus.$emit('close_current_tags');
      this.$router.replace('/paymentAccount');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
